module.exports = __webpack_public_path__ + "assets/img/9ecefddc210c39a7be2254b47c48c254.svg";